"use client";

import { CarrotHarvest } from "./carrot-harvest";
import type { PlayQuestionDTO } from "@/types/quiz";

/** 8 câu hỏi mẫu (Toán lớp nhỏ) cho bản chơi thử công khai của "Hái Cà Rốt". */
const DEMO_QUESTIONS: PlayQuestionDTO[] = [
  { id: "c1", prompt: "5 + 3 bằng bao nhiêu?", options: ["6", "7", "8", "9"], correctIndex: 2 },
  { id: "c2", prompt: "12 − 4 bằng bao nhiêu?", options: ["6", "8", "9", "10"], correctIndex: 1 },
  { id: "c3", prompt: "Số nào lớn nhất?", options: ["15", "19", "17", "18"], correctIndex: 1 },
  { id: "c4", prompt: "2 × 4 bằng bao nhiêu?", options: ["6", "7", "8", "10"], correctIndex: 2 },
  { id: "c5", prompt: "Một tuần có bao nhiêu ngày?", options: ["5 ngày", "6 ngày", "7 ngày", "8 ngày"], correctIndex: 2 },
  { id: "c6", prompt: "10 + 6 bằng bao nhiêu?", options: ["14", "15", "16", "17"], correctIndex: 2 },
  { id: "c7", prompt: "18 − 9 bằng bao nhiêu?", options: ["7", "8", "9", "10"], correctIndex: 2 },
  { id: "c8", prompt: "3 × 3 bằng bao nhiêu?", options: ["6", "8", "9", "12"], correctIndex: 2 },
];

/** Bản chơi thử công khai (không đăng nhập, không gọi API) cho "Hái Cà Rốt". */
export function CarrotDemo() {
  return <CarrotHarvest questions={DEMO_QUESTIONS} onFinish={() => {}} />;
}
